import React, { FormEvent, useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { useReactFlow, applyNodeChanges, ReactFlowInstance } from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { NodeDataStoreMultiSelectWidget } from "./components/NodeDataStoreMultiSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-data-reset-node-configuration";
import {
    Button
} from '@mui/material';

export const WorkflowDataResetNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleShowDataResetModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        'custom_error_message': {
            'ui:widget': 'textarea'
        },
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget,
        NodeDataStoreMultiSelectWidget: NodeDataStoreMultiSelectWidget
    }

    useEffect( (): void => {
        if (context.activeEditDataResetNode !== undefined && context.activeEditDataResetNode.data !== undefined) {
            setFormData(context.activeEditDataResetNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showDataResetModal }
            title={ "Data Reset Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditDataResetNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );

}